import { render, staticRenderFns } from "./ParagraphFirstLetterBig.vue?vue&type=template&id=ed9ea494&scoped=true&"
import script from "./ParagraphFirstLetterBig.vue?vue&type=script&lang=js&"
export * from "./ParagraphFirstLetterBig.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphFirstLetterBig.vue?vue&type=style&index=0&id=ed9ea494&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9ea494",
  null
  
)

export default component.exports